import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FOLDER_MODE } from 'apps/resource-portal/src/app/constants/app.constant';
import { FolderService } from 'apps/resource-portal/src/app/services/folder.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'concourse-add-edit-folder',
  templateUrl: './add-edit-folder.component.html',
  styleUrls: ['./add-edit-folder.component.scss']
})
export class AddEditFolderComponent implements OnInit, OnDestroy {
  @Input() projectId;
  @Input() selectedFolder;
  @Input() mode = FOLDER_MODE.ADD;
  @Input() type = 1;
  folderForm: UntypedFormGroup;
  $unsubscribe = new Subject<void>();
  constructor(public activeModal: NgbActiveModal, private _folderService: FolderService) { }

  ngOnInit(): void {
    console.log(this.selectedFolder);
    
    this.folderForm = new UntypedFormGroup({
      'name': new UntypedFormControl((this.mode == FOLDER_MODE.EDIT) ? this.selectedFolder?.text : '', [Validators.required]),
      'type': new UntypedFormControl(this.type)
    });
  }

  submitForm(mode) {
    if (mode == FOLDER_MODE.ADD) {
      this._folderService.addFolder(this.projectId, this.folderForm.get('name').value, this.folderForm.get('type').value, this.selectedFolder?.value).pipe(
        takeUntil(this.$unsubscribe)
      ).subscribe((result) => {
        if (result && result.status <= 300) {
          this.activeModal.close('New Folder Added');
        } else {
          this.activeModal.close('error');
        }
      });
    } else {
      this._folderService.renameFolder(this.selectedFolder.value, this.folderForm.get('name').value).pipe(
        takeUntil(this.$unsubscribe)
      ).subscribe((result) => {
        if (result && result.status <= 300) {
          this.activeModal.close('Folder Renamed');
        } else {
          this.activeModal.close('error');
        }
      });
    }
  }


  ngOnDestroy() {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }

}
